var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component, Children, cloneElement, createRef } from "react";
import { Container, Cell, Thumbnail } from "./styled/slider-fullscreen-thumbnails";
var SliderFullscreenThumbnails = /** @class */ (function (_super) {
    __extends(SliderFullscreenThumbnails, _super);
    function SliderFullscreenThumbnails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = createRef();
        _this.lastChildRef = createRef();
        _this.activeChildRef = createRef();
        _this.state = {
            offset: 0,
            imagesLoaded: false
        };
        _this.loadedImagesCount = 0;
        _this.handleOnImageLoad = function () {
            _this.loadedImagesCount = _this.loadedImagesCount + 1;
            if (_this.loadedImagesCount + 1 >= Children.count(_this.props.children)) {
                _this.setState({ imagesLoaded: true });
            }
        };
        _this.calculateOffset = function () {
            var _a, _b, _c;
            var offset = _this.state.offset;
            var parentRect = ((_a = _this.props.parentRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {
                left: 0
            };
            var activeChildRect = ((_b = _this.activeChildRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) || {
                left: 0,
                width: 0
            };
            var containerRect = ((_c = _this.ref.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) || {
                width: 0
            };
            var slideCenter = Math.abs(parentRect.left - activeChildRect.left) +
                activeChildRect.width / 2;
            var containerCenter = containerRect.width / 2;
            var diff = slideCenter - containerCenter;
            var nextDiff = offset - diff;
            // If you are the last child you are the active child.
            var lastChildRect = (_this.lastChildRef.current ||
                _this.activeChildRef.current).getBoundingClientRect();
            if (_this.props.currentSlideIndex === 0) {
                _this.setState({ offset: 0 });
            }
            else {
                // Stop the scrolling if there are less than enough thumbnails to fill the screen
                if (Math.abs(parentRect.left - lastChildRect.right) < containerRect.width) {
                    return;
                }
                // If we don't have any room to the left, scroll to zero
                if (nextDiff > 0) {
                    _this.setState({ offset: 0 });
                }
                // Calculates the end of the div
                else if (Math.abs(parentRect.left - lastChildRect.right) - diff <
                    containerRect.width) {
                    _this.setState({
                        offset: offset +
                            (containerRect.width -
                                Math.abs(parentRect.left - lastChildRect.right))
                    });
                }
                // Normal calculations
                else {
                    _this.setState({ offset: offset - diff });
                }
            }
        };
        return _this;
    }
    SliderFullscreenThumbnails.prototype.render = function () {
        var _this = this;
        var _a = this.props, currentSlideIndex = _a.currentSlideIndex, isSliding = _a.isSliding, children = _a.children;
        var offset = this.state.offset;
        return (React.createElement(Container, { ref: this.ref, style: { transform: "translateX(" + offset + "px)" } }, Children.map(children, function (child, index) {
            var el = child;
            var isActive = currentSlideIndex === index;
            var isLastChild = index === Children.count(children) - 1;
            return (React.createElement(Cell, { ref: isActive
                    ? _this.activeChildRef
                    : isLastChild
                        ? _this.lastChildRef
                        : null },
                React.createElement(Thumbnail, { isActive: isActive, disabled: isSliding, onClick: function () { return _this.props.onClick(index); } }, cloneElement(el, {
                    style: __assign(__assign({}, el.props.style), { width: "100%", height: "100%" }),
                    onLoad: _this.handleOnImageLoad
                }))));
        })));
    };
    SliderFullscreenThumbnails.prototype.componentDidMount = function () {
        this.calculateOffset();
    };
    SliderFullscreenThumbnails.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.currentSlideIndex !== this.props.currentSlideIndex ||
            (!prevState.imagesLoaded && this.state.imagesLoaded)) {
            this.calculateOffset();
        }
    };
    return SliderFullscreenThumbnails;
}(Component));
export default SliderFullscreenThumbnails;
